import { render, staticRenderFns } from "./manufactureItem.vue?vue&type=template&id=3eef11ac&scoped=true&"
import script from "./manufactureItem.vue?vue&type=script&lang=js&"
export * from "./manufactureItem.vue?vue&type=script&lang=js&"
import style0 from "./manufactureItem.vue?vue&type=style&index=0&id=3eef11ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eef11ac",
  null
  
)

export default component.exports